import {useParams} from 'react-router-dom';

import {useInboxes} from 'src/services/api/inboxes/use-inboxes';
import {useLoggedInUser} from 'src/services/api/auth';


const useCurrentInbox = () => {
    const { id: viewId } = useParams<{ id: string }>();

    const {data: inboxes} = useInboxes();

    const { data: loggedInUser } = useLoggedInUser();
    const inbox = inboxes?.find(v => v.id === Number(viewId));
    const isDefaultInbox = !inbox;

    const isOwner = isDefaultInbox ? false : loggedInUser?.id === inbox.landlord_user_id;

    return {
        inbox,
        isOwner,
        isDefaultInbox,
    };
};

export default useCurrentInbox;
